import React from 'react';
import styled from 'styled-components';
import Icon from '../../../../components/Icon';
import { I18n } from 'react-redux-i18n';

const TasterSubscriptionCMSContainer = styled.div`
  padding: 30px;
  display: flex;
  flex-direction: row;
  background-color: rgba(245, 245, 245, 0.5);
  border-radius: 4px;

  .tsTitle {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 20px;
    color: #212529;
    margin-bottom: 20px;
    text-transform: uppercase;
  }

  .tsText {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 14px;
    line-height: 24px;
    color: ${(props) => props.theme.colors['dark-two']};
  }

  .tsTextBold {
    font-family: ${(props) => props.theme.fonts.oswald};
  }

  .tsLogoContainer {
    margin-left: auto;
    font-size: 140px;
    opacity: 0.1;
    margin-right: -20px;
    margin-top: -40px;
  }

  .tsTextContainer {
    width: 80%;
    white-space: normal;
    line-height: 24px;
  }
`;

const TasterSubscriptionCMS = () => (
  <TasterSubscriptionCMSContainer>
    <div className="tsTextContainer">
      <h1 className="tsTitle">{I18n.t('tasterSubscription.cmsTitle')}</h1>
      <p className="tsText">
        {I18n.t('tasterSubscription.cms1')}
        <br />
        {I18n.t('tasterSubscription.cms2')}
        <br />
        {I18n.t('tasterSubscription.cms3')}
      </p>
    </div>
    <div className="tsLogoContainer">
      <Icon icon="logo-medium" />
    </div>
  </TasterSubscriptionCMSContainer>
);

export default TasterSubscriptionCMS;
